import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIClient } from "src/app/core/api-client/contracts/api-client.service";
import { ICreateDeviceType } from "src/app/shared/models/ICreateDeviceType";
import { IDeviceType } from "src/app/shared/models/IDevice-type";

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService {
  resource = 'devicetypes';
  constructor(private client: APIClient) { }
  getAllDeviceTypesWithModelsCount(): Observable<IDeviceType[]> {
    return this.client.get<IDeviceType[]>(`${this.resource}/getAllDeviceTypesWithModelsCount`);
  }
  getDeviceTypeWithModelsByTypeId(deviceTypeId: number): Observable<IDeviceType[]> {
    return this.client.get<IDeviceType[]>(`${this.resource}/getDeviceTypeWithModelsByTypeId/${deviceTypeId}`)
  }
  getAllDeviceTypesWithModels(): Observable<IDeviceType[]> {
    return this.client.get<IDeviceType[]>(`${this.resource}/getAllDeviceTypesWithModels`);
  }
  createDeviceType(createDeviceType: ICreateDeviceType): Observable<ICreateDeviceType> {
    return this.client.post<ICreateDeviceType>(`${this.resource}/createDeviceType`, createDeviceType);
  }
}